module fdm.pilotPerformance {

    angular.module('fdm.pilotPerformance', []);
}